module.exports = __webpack_public_path__ + "img/precs4.7c69dec9.png";